var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Address",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-8 -6)",
    fill: "currentColor",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31229",
    "data-name": "Path 31229",
    d: "M9.856,18.284a.383.383,0,0,1-.252-.1C9.334,17.95,3,12.3,3,6.856a6.856,6.856,0,1,1,13.713,0c0,5.442-6.334,11.094-6.6,11.332A.383.383,0,0,1,9.856,18.284Zm0-17.522A6.1,6.1,0,0,0,3.762,6.856c0,4.508,4.914,9.415,6.094,10.528,1.18-1.113,6.094-6.019,6.094-10.528A6.1,6.1,0,0,0,9.856.762Z",
    transform: "translate(-3)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31230",
    "data-name": "Path 31230",
    d: "M10.809,11.618a3.809,3.809,0,1,1,3.809-3.809A3.813,3.813,0,0,1,10.809,11.618Zm0-6.856a3.047,3.047,0,1,0,3.047,3.047A3.05,3.05,0,0,0,10.809,4.762Z",
    transform: "translate(-3.953 -0.953)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.ee9af50de30e161171abdd7f88f9d011.svg";
export { ForwardRef as ReactComponent };